const ROOT = '/'

export function imageProps(imageSrc, className) {
  return {
    lazyLoad: true,
    src: imageSrc,
    className: className,
    alt: 'image',
  }
}

export function getIcon(icon) {
  return require(`../../../common_assets/images/${icon}_icon.svg`)
}

export function getNavItemStyle(navItemsSize) {
  return navItemsSize > 4 ? 'nav__item__smaller' : 'nav__item'
}

export function getItemsContainerClass(itemsSize) {
  if (itemsSize < 7) return 'items-container__small'
  else if (itemsSize > 6 && itemsSize < 14) {
    return 'items-container__medium'
  }
  return 'items-container__large'
}

export function getItemContainerClass(itemsSize) {
  return itemsSize < 4 ? 'item__container__small' : 'item__container__large'
}

export function redirectToItemFeed(url) {
  location.replace(location.origin + url)
}

export function getPath() {
  return typeof window !== 'undefined' ? window.location.pathname : ROOT
}



// WEBPACK FOOTER //
// ./provolution/app/views/provolution/components/header/navigation/util.js